// https://gitlab.com/zapier/editor/-/blob/610a98b70a496540cbe8f752b06b1df647fd224a/packages/editor-core/src/utils/coerceValueToBoolean.ts

const coerceValueToBoolean = (value: any): boolean => {
  if (typeof value !== 'string') {
    return value ? true : false;
  }
  value = value.toLowerCase();
  if (
    value === '' ||
    value === 'no' ||
    value === 'off' ||
    value === 'false' ||
    value === '0'
  ) {
    return false;
  }
  return true;
};

export default coerceValueToBoolean;
